import $ from 'jquery';
import {showFormResponse} from "../common/json-response";

export default function() {
  const changeItems = document.querySelectorAll('.change-right-answer-block .change-item');

  if (!changeItems.length) {
    return;
  }

  const currentVariants = document.querySelectorAll('.work_right_answer_variant');
  const statusWrapper = document.querySelector('.action-status-messages');

  const changeItemsHandler = function (e) {
    e.preventDefault();
    const currentChangeItem = e.currentTarget;
    const customFieldUuid   = currentChangeItem.getAttribute('data-custom-field-uuid');
    const workFieldUuid   = currentChangeItem.getAttribute('data-custom-work-field-uuid');
    const fieldFormat = currentChangeItem.getAttribute('data-custom-field-format');
    const isCorrect = currentChangeItem.getAttribute('data-is-correct');
    const changeVariantUuid = currentChangeItem.getAttribute('data-change-uuid');

    const currentVariantParentBlock = currentChangeItem.closest('.work_right_answer_variant');
    const currentWorkFieldParentBlock = currentChangeItem.closest('.desc-list__item.organizer-work');
    const currentVariantBlock = currentVariantParentBlock.querySelector('.work_right_answer_variant_details');
    const currentChangeItemBlock = currentChangeItem.closest('.change-right-answer-block');

    let url = currentChangeItemBlock.getAttribute('data-url');

    $.ajax({
      type: "POST",
      url: url,
      dataType: 'json',
      data: {
        'type': fieldFormat,
        'isCorrect': isCorrect,
        'customFieldUuid': customFieldUuid,
        'workFieldUuid': workFieldUuid,
        'changeVariantUuid': changeVariantUuid
      },
      success: function (data) {
        if (data.status === 'success') {
          const valueBlock = currentVariantBlock.querySelector('.variant_value');
          const valueScoreBlock = currentVariantBlock.querySelector('.score_value');
          const changeItemValue = currentChangeItem.querySelector('.change_item_value');
          const changeItemScore = currentChangeItem.querySelector('.change_item_score');
          const commonWorkFieldsVariantsScore = document.querySelector('.work_score_for_organizer .score_value');
          const currentWorkFieldVariantsScore = currentWorkFieldParentBlock.querySelector('.right_answer_field_score .score_value');

          if (changeVariantUuid && isCorrect === "1") {
            valueBlock.innerText = changeItemValue.innerText;
          }

          if (valueScoreBlock) {
            const currentAnswerScore = parseInt(valueScoreBlock.innerText);
            const currentFieldCommonScore = parseInt(currentWorkFieldVariantsScore.innerText);
            const workCommonScore = parseInt(commonWorkFieldsVariantsScore.innerText);
            const changeItemScoreValue = parseInt(changeItemScore.innerText);

            const newFieldCommonScore = (currentFieldCommonScore - currentAnswerScore) + changeItemScoreValue;
            const newWorkCommonScore = (workCommonScore - currentAnswerScore) + changeItemScoreValue;
            valueScoreBlock.innerText = changeItemScore.innerText;
            currentWorkFieldVariantsScore.innerText = newFieldCommonScore;
            commonWorkFieldsVariantsScore.innerText = newWorkCommonScore;
          }

          let variantIconName;

          if (isCorrect === "0") {
            variantIconName = 'wrong-circle.svg';
            currentVariantBlock.classList.remove('right_answer');
            currentVariantBlock.classList.add('wrong_answer');
          } else {
            variantIconName = 'right-circle.svg';
            currentVariantBlock.classList.remove('wrong_answer');
            currentVariantBlock.classList.add('right_answer');
          }

          const variantIsCorrectIcon = currentVariantBlock.querySelector('.is_correct_image_block img');

          if (variantIsCorrectIcon) {
            variantIsCorrectIcon.src = '/img/icons/' + variantIconName;
          }

          currentChangeItemBlock.classList.add('d-none');
        } else if (data.messages) {
          showFormResponse(data);
        }
      },
      error: function (data) {
        if (data.messages) {
          showFormResponse(data);
        } else {
          const message = 'Возникла ошибка. Обратитесь пожалуйста в тех. поддержку';
          const statusMsg = document.createElement('div');
          statusMsg.classList.add(['alert']);
          statusMsg.classList.add(['alert_error']);
          statusMsg.innerHTML = message;
          statusWrapper.appendChild(statusMsg);
        }
      },
    });
  };

  currentVariants?.forEach(function (currentVariant) {
    currentVariant.addEventListener('click', function (e) {
      const item = e.currentTarget;
      const changeItemsAllBlocks = document.querySelectorAll('.work_right_answer_variant .change-right-answer-block');

      changeItemsAllBlocks?.forEach(function (block) {
        block.classList.add('d-none');
        block.classList.remove('active');
      });

      const changeItemsBlock = item.querySelector('.change-right-answer-block');

      if (changeItemsBlock) {
        changeItemsBlock.classList.add('active');
        changeItemsBlock.classList.remove('d-none');
      }
    });
  });

  changeItems?.forEach(function (button) {
    button.addEventListener('click', changeItemsHandler);
  });

  document.addEventListener('click', function (e) {
    if (e.target.closest('.work_right_answer_variant_details')) {
      return;
    }

    const activeVariantsBlock = document.querySelector('.change-right-answer-block.active');
    const targetVariantsBlock = e.target.closest('.change-right-answer-block');

    if (activeVariantsBlock && targetVariantsBlock === null) {
      activeVariantsBlock.classList.remove('active');
      activeVariantsBlock.classList.add('d-none');
    }
  });
}